import { GlobalNotificationsService } from "./../services/global-notifications/global-notifications.service";
import { Router } from "@angular/router";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.css"],
})
export class NotificationsComponent implements OnInit {
  notifications;
  pageTest: any = 1;
  page: number = 1;
  last_page: number;
  lg: string = "lg";
  notifications_raw_data: any;
  last_page_url: any;
  isLoading = false;
  type = "";
  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService,
    private globalNotificationsService: GlobalNotificationsService,
    private leadsService: LeadsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllNotifications();
  }

  goToReservation(id) {
    let reservation = {
      id: id,
    };
    window.localStorage.setItem(
      "reservationDetails",
      JSON.stringify(reservation)
    );
    this.router.navigate(["/pages/project/view-reservation"]);
  }

  goToPage(notification) {
    console.log(notification);
    if (notification.type == "Reservation") {
      let reservation = {
        id: notification.reservation_id,
      };
      window.localStorage.setItem(
        "reservationDetails",
        JSON.stringify(reservation)
      );
      this.router.navigate(["/pages/project/view-reservation"]);
      return;
    } else if (notification.type == "Unit") {
      this.router.navigate(["/pages/projects/view-unit"], {
        queryParams: {
          project_id: null,
          unit_id: notification.unit_id,
        },
      });
      return;
    } else if (notification.type == "Block Request") {
      this.router.navigate(["/pages/projects/view-unit"], {
        queryParams: {
          project_id: null,
          unit_id: notification.unit_id,
        },
      });
      return;
    } else if (notification.type == "Lead") {
      this.router.navigate([`/pages/leads/${notification.lead_id}`]);
      return;
    } else if (notification.type == "Export") {
      this.router.navigate([`/pages/export-history`]);
      return;
    }
  }

  getAllNotifications(type = "") {
    this.isLoading = true;
    this.type = type;
    this.slimLoadingBarService.start();
    this.globalNotificationsService.fetchNotifications({ type }).subscribe(
      (res: any) => {
        this.notifications_raw_data = res;
        this.last_page_url = res.last_page_url;
        this.last_page = res.last_page;
        this.notifications = res.data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => {
        this.slimLoadingBarService.complete();
        this.isLoading = false;
      }
    );
  }

  pageChange(event) {
    console.log(event);
    // this.paginate(event);
    console.log(this.last_page_url);
    let arr = this.last_page_url.split("?");
    let selectedUrl = `${arr[0]}?page=${event}`;
    // if (this.filterActive) {
    //   this.infiniteWithFilter(selectedUrl, event)
    // } else {
    //   this.infinite(selectedUrl, event);
    // }
    this.infinite(selectedUrl, event);
  }

  infinite(url, event) {
    this.leadsService.infinit(url).subscribe(
      (res: any) => {
        this.notifications_raw_data = res;
        this.last_page_url = res.last_page_url;
        this.notifications = this.notifications.concat(res.data);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  onScroll() {
    this.page += 1;
    this.last_page >= this.page && this.pageChange(this.page);
  }
}



// WEBPACK FOOTER //
// ./src/app/notifications/notifications.component.ts